import { css, html } from "lit";
import { customElement, query, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";

import "./MediaImport";
import { IPlace } from "../../models/Models";

@customElement("ds-media-import-dialog")
export class MediaImportDialog extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
        `,
    ];

    @property({ type: Object }) place?: IPlace;
    @query("#dialog") protected _dialog: SlDialog | undefined;

    override render() {
        return html`<sl-dialog
            id="dialog"
            open
            label="Contribute media to a place"
            @ds-accept=${() => this._dialog?.hide()}
        >
            <ds-media-import .place=${this.place}></ds-media-import>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-media-import-dialog": MediaImportDialog;
    }
}
